import $ from 'jquery'

const Request = (($) => {

	class Request {

		constructor(){

		}

		getQuery(name, defaultValue){
			let i = 0,
				query = window.location.search.substring(1),
				vars = query.split('&')

			for(i = 0; i < vars.length; i++){
				let pair = vars[i].split('=')
				if(decodeURIComponent(pair[0]) == name){
					return decodeURIComponent(pair[1])
				}
			}
			return defaultValue
		}
	}

	return new Request()
})($)

export default Request
